"use strict";
// TURBO:LOAD
document.addEventListener("turbo:load", () => {
  let config = {
    colors: {
      primary: "#696cff",
      secondary: "#8592a3",
      success: "#71dd37",
      info: "#03c3ec",
      warning: "#ffab00",
      danger: "#ff3e1d",
      dark: "#233446",
      black: "#000",
      white: "#fff",
      body: "#f4f5fb",
      headingColor: "#566a7f",
      axisColor: "#a1acb8",
      borderColor: "#eceef1",
    },
  };
}); // TURBO:LOAD
